export default {
  route: {
    home: 'Home',
    user: 'User Center',
    userManage: 'Users',
    createUser: 'Create User',
    editUser: 'Edit User',
    shop: 'Shop Center',
    shopManage: 'Shops',
    createShop: 'Create Shop',
    editShop: 'Edit Shop'
  },
  customize: {
    add: 'Add',
    delete: 'Delete',
    refresh: 'Refresh',
    edit: 'Edit',
    loading: 'Loading...',

    // 用户中心
    ID: 'ID',
    loginName: 'Login Name',
    userGroup: 'User Group',
    phoneNumber: 'Phone Number',
    createAt: 'Create Time',
    operate: 'Operate',
    email: 'Email',

    // 用户详情
    password: 'Password',
    root: 'Root',
    manager: 'Administrator',
    pleaseSelectAUserRole: 'Please Select a User Role',
    create: 'Create',
    update: 'Update',

    // 店铺中心
    shopLogo: 'Shop Logo',
    shopName: 'Shop Name',
    shopType: 'Shop Type',
    shopUrls: 'Shop Urls',
    shopActivity: 'Status',
    shopReady: 'Published',
    shopWaitForReview: 'Pending',

    // 店铺详情
    merchantName: 'Merchant Name',
    merchantAddress: 'Merchant Address',
    merchantContactPhone: 'Contact Number',
    merchantContactEmail: 'Merchant Email',
    merchantContactPerson: 'Contact Person',
    accountManager: 'Administrator',
    accountManagerMobilePhone: 'Admin Mobile',
    district: 'District',
    shopProfile: 'Shop Introduction',
    shopDetailsInstroduce: 'Shop Details',
    pleaseChooseShopType: 'Please select shop type',
    company: 'Company',
    personal: 'Individual',
    shopDomain: 'Shop Site',
    loginEmail: 'Login Email',
    uploadFile: 'Drag the file here, or ',
    clickUpload: ' Upload',
    uploadAlert: 'Can only upload jpg/png files up to 500kb',
    editPassword: 'Edit Password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    cancelPassword: 'Cancel',
    submitPassword: 'Submit',
    myPayMid: 'MyPay ID',
    myPayApiKey: 'MyPay Api Key',
    shopPaymentDetail: 'Offline Payment Details',
    tongUrl: 'Synchronous Callback URL',
    yiUrl: 'Asynchronous Callbacks URL',

    // goods
    barcode: 'Barcode',
    // 提示信息
    switchLanguageSuccess: 'Switch Language Successfully',
    // 快递中心
    expressType: 'Express Type',
    createExpressType: 'Create Express Type'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  }
}
